var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "height": "100%",
      "z-index": "1"
    },
    attrs: {
      "fill-height": ""
    }
  }, [_c('form-loader', {
    attrs: {
      "form": this.form
    },
    on: {
      "load": _vm.handleLoginFormLoaded
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }